import React from "react";
import { Spinner } from "../Spinner/Spinner";
import "./button.css";
import * as Icons from "@material-ui/icons";

function DynamicIcon({ name, fontSize = "default", color = "inherit" }) {
  const IconComponent = Icons[name];

  if (!IconComponent) {
    return null;
  }

  return <IconComponent fontSize={fontSize} color={color} className="button__icon" />;
}

export const Button = ({
  primary = false,
  outlined = false,
  size = "medium",
  backgroundColor,
  children,
  disabled = false,
  fullWidth = false,
  loading = false,
  className = "",
  icon = "",
  ...props
}) => {
  const mode = primary
    ? "button--primary"
    : outlined
      ? "button--outlined"
      : "button--secondary";
  const sizeClass = `button--${size}`;
  const widthClass = fullWidth ? "button--full-width" : "";
  const loadingClass = loading ? "button--loading" : "";

  return (
    <button
      type="button"
      className={[
        "button",
        mode,
        sizeClass,
        widthClass,
        loadingClass,
        className,
      ].join(" ")}
      disabled={disabled || loading}
      style={backgroundColor ? { backgroundColor } : {}}
      {...props}
    >
      {icon && <DynamicIcon name={icon} />}
      {loading ? (
        <span className="button__loading-indicator">
          <Spinner
            primaryColor={
              primary
                ? "var(--fg-neutral-subtler)"
                : outlined
                ? "var(--fg-brand-strong)"
                : "var(--fg-neutral-default)"
            }
            secondaryColor={primary ? "transparent" : undefined}
            size={size === "small" ? 16 : size === "large" ? 24 : 20}
          />
        </span>
      ) : null}
      {children}
    </button>
  );
};